<template>
	<el-container class="page">
		<el-header height="80px" class="baseheader">
			<div class="basemaincont">
				<hear></hear>
			</div>
		</el-header>
		<el-main class="basemain">
			<div class="basemaincont">
				<router-view></router-view>
			</div>
		</el-main>
	</el-container>
</template>
<script>
	import hear from '@/components/base/hear.vue'
	export default {
		name: 'index',
		components: {
			hear
		},
		data() {
			return {}
		},
		created() {},
		methods: {}
	}
</script>

<style lang="less">
	.page {
		width: 100vw;
		height: 100vh;
		box-sizing: border-box;

		.baseheader,
		.basemain {
			padding: 0px;

			.basemaincont {
				width: 100%;
				margin: 0 auto;
				max-width: 1200px;
			}
		}

		.baseheader {
			padding: 0 3%;
		}

		.basemain {
			padding: 10px 3%;
			background-color: #f9f9f9;
		}

	}
</style>
